import React from "react";
import { ImageList, ImageListItem, Box } from "@mui/material";
import { GalleryWrapper } from "./styles";
import { IGallery } from "../../store/services/invitations/dto/invitations.dto";
import { useAppDispatch } from "../../store";
import { toggleImageGallerySlides } from "../../store/slices/invitations/invitations.slice";
import AddIcon from "@mui/icons-material/Add";

const InvitationGallery = ({ gallery, canEdit }: { gallery: IGallery[]; canEdit?: boolean }) => {
	const dispatch = useAppDispatch();
	return (
		<GalleryWrapper>
			{gallery.length === 0 && canEdit ? (
				<Box className={"add_gallery"}>
					<AddIcon />
				</Box>
			) : (
				<Box className={"gallery-list_wrapper"}>
					<ImageList variant={"masonry"} cols={2} gap={8}>
						{gallery
							.filter(i => i.image_url)
							.map((item, index) => {
								return (
									<ImageListItem key={item._id}>
										<img
											srcSet={`${item.image_url}`}
											src={`${item.image_url}`}
											alt={`Gallery  ${item._id}`}
											loading="lazy"
											onClick={() => dispatch(toggleImageGallerySlides(index))}
										/>
									</ImageListItem>
								);
							})}
					</ImageList>
					<ImageList cols={2} gap={8}>
						{gallery
							.filter(i => i.video_url)
							.map((item, index) => {
								return (
									<ImageListItem key={item._id} cols={2}>
										<video src={item.video_url} controls style={{ maxHeight: "450px" }} />
									</ImageListItem>
								);
							})}
					</ImageList>
				</Box>
			)}
		</GalleryWrapper>
	);
};

export default InvitationGallery;
